export const primary = '#52C41A'
export const primaryHover = '#73D13C'
export const primaryClick = '#389E0E'

export const primaryLight = '#DDF4D2'
export const primaryLightGradient = 'linear-gradient(202deg, rgba(166,216,73,0.1) 0%, rgba(116,193,89,0.1) 100%);'

export const secondary = '#ECF9E6'
export const secondaryHover = '#F3FDEE'
export const secondaryClick = '#DAE8D4'

export const special = 'linear-gradient(270deg, #11AF60 0%, #52C41A 100%)'
export const dangerHover = 'linear-gradient(225deg, #FF1F1F 0%, #F78900 100%)'

export const disabled = '#F7F7F7'
export const shadowColor = '#041B0F'

export const defaultText = '#041B0F'
export const defaultTextHover = '#0E2919'
export const defaultTextClick = '#000000'

export const secondaryText = '#041B0F99'
export const secondaryTextHover = '#737373'
export const secondaryTextClick = '#404040'

export const leastText = '#041B0F66'
export const leastTextHover = '#A6A6A6'
export const leastTextClick = '#737373'

export const disabledText = '#BFBFBF'
export const specialText = '#737971'

export const success = '#52C41A'
export const warning = '#FFBF00'
export const error = '#FF1F1F'

export const grayText = '#0B310440'
export const grayText2 = '#97A4B0'
export const errorText = '#FF1F1F'
export const infoText = '#2F7CE9'

export const gray = '#DADCE0'
export const grayLight = '#F8F8F8'
export const grayLabel = '#717579'
export const hover = 'rgba(82, 196, 26, 0.8)'
export const hoverLight = 'rgba(82, 196, 26, 0.11)'

export const darkBg = '#072120'
export const grayBg = '#F5F7FD'

export const grayBorder = '#E7EAEF'

export const caption2 = 'rgba(0, 0, 0, 0.50)'

export const notificationsBg = 'rgba(255, 24, 68, 1)'
